"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9101],{

/***/ 79101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cms_CMS_RowCardGroup; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/layouts/Section/index.js + 1 modules
var Section = __webpack_require__(46350);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/cms/CMS_GridCards.js





var CMS_CardProduct = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(7261), __webpack_require__.e(5761)]).then(__webpack_require__.bind(__webpack_require__, 31751));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31751)
            ];
        }
    }
});
var CMS_CardImageText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3688).then(__webpack_require__.bind(__webpack_require__, 63688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63688)
            ];
        }
    }
});
var CMS_CardSeeMore = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 155).then(__webpack_require__.bind(__webpack_require__, 60155));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60155)
            ];
        }
    }
});
var components = {
    CARD_IMAGE_TOP: CMS_CardImageText,
    CARD_IMAGE_LEFT: CMS_CardImageText,
    CARD_IMAGE_RIGHT: CMS_CardImageText,
    CARD_IMAGE_FORM_BOTTOM_LEFT: CMS_CardImageText,
    CARD_PRODUCT: CMS_CardProduct,
    CARD_SEE_MORE: CMS_CardSeeMore,
    image_top: CMS_CardImageText,
    image_side: CMS_CardImageText,
    description_form: CMS_CardImageText,
    blog: CMS_CardImageText,
    product: CMS_CardProduct
};
var RenderRow = function(param) {
    var data = param.data, nbColsD = param.nbColsD, nbColsM = param.nbColsM;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row",
        children: data.map(function(item, idx) {
            var layout = item.layout ? item.layout : {};
            var isSeeMoreCard = idx === data.length - 1 && (layout === "CARD_IMAGE_TOP" || layout === "image_top") && item.button && item.button.link && item.content && item.content.includes("Ver todo");
            var CustomComponent = layout ? isSeeMoreCard ? components["CARD_SEE_MORE"] : components[layout] : {};
            if (!CustomComponent) return "";
            else {
                var numColumnsD = parseInt(nbColsD) === 1 ? "lg:w-full" : nbColsD >= 4 ? "lg:w-1/4" : "lg:w-1/" + nbColsD;
                var numColumnsM = parseInt(nbColsM) === 1 ? "sm:w-full" : nbColsM >= 4 ? "sm:w-1/4" : "sm:w-1/" + nbColsM;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: (item === null || item === void 0 ? void 0 : item.product) ? "product-card-".concat(item.product.sku) : null,
                    className: classnames_default()("mb-4 px-5 sm:mb-6 sm:px-2 md:px-2", "w-full ".concat(numColumnsM, " ").concat(numColumnsD)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomComponent, {
                        content: item
                    })
                }, idx);
            }
        })
    });
};
var CMS_GridCards_Comp = function(param) {
    var content = param.content, nbColsD = param.nbColsD, nbColsM = param.nbColsM;
    var cards = Object.values(content);
    if (!cards || cards.length <= 0) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container-fluid m-0 mx-auto sm:max-w-screen-md md:max-w-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderRow, {
            data: content,
            nbColsD: nbColsD,
            nbColsM: nbColsM
        })
    });
};
CMS_GridCards_Comp.defaultProps = {};
CMS_GridCards_Comp.propTypes = {
    content: prop_types.array.isRequired,
    nbColsD: prop_types.string,
    nbColsM: prop_types.string
};
var CMS_GridCards = /*#__PURE__*/ react.memo(CMS_GridCards_Comp);
/* harmony default export */ var cms_CMS_GridCards = (CMS_GridCards);

;// CONCATENATED MODULE: ./components/cms/CMS_RowCardGroup.js







var CMS_RowCardGroup_Comp = function(param) {
    var content = param.content, _id = param.id, id = _id === void 0 ? "" : _id;
    if (!content || content.length <= 0) return "";
    var element = !Array.isArray(content) ? [
        content
    ] : content;
    return element.map(function(cardGroup, index) {
        var title = cardGroup.title;
        var background = cardGroup.background_color;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            id: (0,src/* get_ */.jR)(content, [
                "fragment_id"
            ], ""),
            style: {
                backgroundColor: background ? background : background === "no" ? "transparent" : ""
            },
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-fluid",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 w-full px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-between text-center sm:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "font-heading text-h2 font-heading-regular",
                                            children: title
                                        }),
                                        cardGroup.button && cardGroup.button.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                                            underline: true,
                                            label: cardGroup.button.text,
                                            href: cardGroup.button.link,
                                            children: cardGroup.button.text
                                        })
                                    ]
                                }),
                                cardGroup.content ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center font-body text-normal font-body-regular sm:text-left",
                                    dangerouslySetInnerHTML: {
                                        __html: cardGroup.content
                                    }
                                }) : ""
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(cms_CMS_GridCards, {
                    content: cardGroup.cards,
                    nbColsD: cardGroup.columns_desktop ? cardGroup.columns_desktop : 1,
                    nbColsM: cardGroup.columns_mobile ? cardGroup.columns_mobile : 1
                })
            ]
        }, "".concat(cardGroup.title, "+").concat(cardGroup.fragment_id, "+").concat(index));
    });
};
CMS_RowCardGroup_Comp.defaultProps = {};
CMS_RowCardGroup_Comp.propTypes = {
    content: prop_types.oneOfType([
        prop_types.array,
        prop_types.object
    ]).isRequired
};
var CMS_RowCardGroup = /*#__PURE__*/ react.memo(CMS_RowCardGroup_Comp);
/* harmony default export */ var cms_CMS_RowCardGroup = (CMS_RowCardGroup);


/***/ })

}]);